module.exports = __webpack_public_path__ + "img/Ellipse7.a4177388.png";